const isAdmin = (auth) => auth.isSupervisor() || auth.isForeningSupervisor();

export const canAccessPortal = (auth) => {
  return (
    auth.isAuthenticated && !auth.isOnboarding() && auth.creditors.length > 0
  );
};

export const canAccessMainPortal = (auth) => {
  return (
    auth.isAuthenticated &&
    !auth.isOnboarding() &&
    !isAdmin(auth) &&
    auth.creditors.length > 0
  );
};

export const canAccessProfile = (auth) => {
  return auth.isAuthenticated;
};

export const canAccessOnboardingSetup = (auth) => {
  // Allow both onboarding users and behalf-mode users (accountants)
  const isAccountant = ['SUPERVISOR', 'USERADMIN', 'CUSTOMERADMIN', 'Supervisor', 'UserAdmin', 'CustomerAdmin'].includes(auth.role);
  const canAccess = auth.isAuthenticated && (auth.isOnboarding() || isAccountant);
  console.log('canAccessOnboardingSetup check:', {
    isAuthenticated: auth.isAuthenticated,
    isOnboarding: auth.isOnboarding(),
    role: auth.role,
    isAccountant,
    canAccess
  });
  return canAccess;
};

export const canAccessAdminFeatures = (auth) => {
  return auth.isAuthenticated && !auth.isUser() && !auth.isOnboarding();
};

// Helper for Redux dispatch protection
export const canDispatchCreditorAPI = (auth) => {
  return auth.isAuthenticated && !auth.isOnboarding() && auth.creditors.length > 0;
};

